import styles from './Badge.module.scss';

export interface BadgeProps {
  className?: string;
  counter: number;
}

const Badge = ({ className, counter }: BadgeProps) => (
  <span className={`${styles.badge}${className ? ` ${className}` : ''}`}>
    {counter}
  </span>
);

export default Badge;
